<template>
  <x-page title="满意度评价" :loading="loading">
    <template v-if="!loading">
      <div :class="_.list">
        <div v-for="(item, index) in list" :key="index" :class="_.item">
          <div :class="_.info">
            <img :class="_.avatar" :src="item.userHeadshot" alt="" />
            <div :class="_.des">
              <p :class="_.name">{{ item.userNickName || item.userTel }}</p>
              <div :class="_.degree">
                满意度：
                <img
                  v-for="i in item.evaluateStar"
                  :key="i"
                  :class="_.star"
                  src="./images/star_2.png"
                  alt=""
                />
                <img
                  v-for="i in 5 - item.evaluateStar"
                  :key="i"
                  :class="_.star"
                  src="./images/star_0.png"
                  alt=""
                />
              </div>
            </div>
          </div>
          <div :class="_.text">{{ item.evaluateContent }}</div>
        </div>
      </div>
    </template>
  </x-page>
</template>

<script>
  import Vue from 'vue'
  import { apiEvaluationEvaluateFindVirtualExchangeEvaluateList } from '@/api'

  export default Vue.extend({
    data() {
      return {
        loading: true,
        list: [],
      }
    },

    mounted() {
      this.getVirtualExchangeEvaluateList()
    },
    methods: {
      async getVirtualExchangeEvaluateList() {
        const data = await apiEvaluationEvaluateFindVirtualExchangeEvaluateList(
          {
            id: this.$route.query.id,
          },
        )
        this.loading = false
        this.list = data
      },
    },
  })
</script>

<style lang="scss" module>
  .list {
    padding: 12px;
    .item {
      margin-bottom: 12px;
      background: #fff;
      padding: 14px 12px;
      border-radius: 12px;
      font-size: 12px;
      .info {
        display: flex;
        .avatar {
          width: 40px;
          height: 40px;
          border-radius: 50%;
          margin-right: 12px;
        }
        .des {
          .name {
            font-family: PingFangSC, PingFang SC;
            font-weight: 500;
            font-size: 14px;
            color: #222222;
            line-height: 20px;
            text-align: left;
            font-style: normal;
          }
          .degree {
            margin-top: 5px;
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            font-size: 12px;
            color: #bebebe;
            line-height: 12px;
            text-align: right;
            font-style: normal;
            .star {
              width: 10px;
            }
          }
        }
      }
      .text {
        margin-top: 11px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 14px;
        color: #222222;
        line-height: 20px;
        text-align: left;
        font-style: normal;
      }
    }
  }
</style>
